import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { MessagesService } from 'shared/domain';
import { TreetopPropertiesProvider } from 'shared/util-common';

import { GuidelineLinkDto } from '@treetop/shared/model';

@Injectable({
  providedIn: 'root',
})
export class UtilsHttpService {
  private http = inject(HttpClient);
  private messages = inject(MessagesService);

  private baseUrl = `${TreetopPropertiesProvider.properties.baseUrl}api`;

  public getComponentLinks(componentCode: string, componentVersion: string, fromId: string): Observable<GuidelineLinkDto[]> {
    return this.http
      .get<
        GuidelineLinkDto[]
      >(`${this.baseUrl}/util/component-link/${encodeURIComponent(componentCode)}/${encodeURIComponent(componentVersion)}/${fromId}`)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          this.messages.showError('CouldNotLoadComponentLink');
          return throwError(() => err);
        }),
      );
  }
}
